import { InjectionToken } from '@angular/core';

import { environment } from './environment';
export const ENVIRONMENT = new InjectionToken('AVS:ENVIRONMENT', {
  factory: () => environment,
  providedIn: 'root',
});
export { environment } from './environment';
export * from './launch-darkly-config';
